import { isEmpty } from "../helper/common";
import { showEmptyCartModal } from "../helper/showEmptyCartModal";
import { removeFormSubmitStatus } from "../helper/removeFormSubmitStatus";


const WatcherService = function (Cart, Discount, Config, $timeout, Voucher, $filter) {
    var service = {};

    service.factory = function ($scope) {

        var callsDiscount = false;
        var callUpdateDiscount = function () {

            if (callsDiscount) {
                return false;
            }
            callsDiscount = true;
            $scope.ajaxCall('cart', 'updatediscount', 'POST',
                {
                    updateDiscount: true,
                    discount: Discount.item,
                    shippingMethod: Cart.shippingMethod,
                    ticketFormat: Cart.ticketFormat,
                    paymentMethod: Cart.paymentMethod
                },
                function (response) {
                    callsDiscount = false;

                    if (response.voucherRemoved) {
                        $scope.removeVoucherFromCart();
                    }
                    if (response.voucherNotValid) {
                        $scope.displayError(response.voucherNotValid.error);
                        $scope.removeVoucherFromCart();
                    }
                    if (response.discount) {
                        Discount.setDiscount(response.discount, $scope);
                    }
                }
            );
        };
        var focusFirstField = function (formId) {
            var form = document.getElementById(formId);
            if (!form) { return; }
            var first = form.querySelector('input:not([type="hidden"]):not([disabled]), select:not([disabled])');
            if (first) { first.focus(); }
        };

        var checkVariable = function (newValue, oldValue) {
            var resetValue = oldValue && !newValue;
            return (resetValue || newValue && (!oldValue || newValue[ 'id' ] !== oldValue[ 'id' ]));
        };
        var initWatcher = {
            ticketFormat: false,
            shippingMethod: false,
            paymentMethod: false
        };
        $scope.$watch('Cart.ticketFormat', function (newVal, oldVal) {
            if (!initWatcher.ticketFormat || checkVariable(newVal, oldVal)) {
                callUpdateDiscount();
                initWatcher.ticketFormat = true;
            }
        });
        $scope.$watch('Cart.shippingMethod', function (newVal, oldVal) {
            if (!initWatcher.shippingMethod || checkVariable(newVal, oldVal)) {
                callUpdateDiscount();
                initWatcher.shippingMethod = true;
            }
        });
        $scope.$watch('Cart.paymentMethod', function (newVal, oldVal) {
            if (!initWatcher.paymentMethod || checkVariable(newVal, oldVal)) {
                callUpdateDiscount();
                initWatcher.paymentMethod = true;
            }
        });

        $scope.$watch('formStatus', function (newValue, oldValue) {
            if (oldValue[ 'loginMode' ] === false && newValue[ 'loginMode' ] === true) {
                $scope.formStatus.registerMode = false;
                $scope.formStatus.updateMode = false;
                $scope.formStatus.userKnown = false;
            }
            if (oldValue[ 'registerMode' ] === false && newValue[ 'registerMode' ] === true) {
                $scope.formStatus.loginMode = false;
                $scope.formStatus.updateMode = false;
                $scope.formStatus.userNotKnown = false;
                $scope.formStatus.guestMode = false;
            }
            if (oldValue[ 'guestLoggedIn' ] === false && newValue[ 'guestLoggedIn' ] === true) {
                $scope.formStatus.userLoggedIn = false;
                $scope.checkCheckoutPossible();
                $scope.updateCheckoutOptions();
            }
            else if (oldValue[ 'guestLoggedIn' ] === true && newValue[ 'guestLoggedIn' ] === false) {
                removeFormSubmitStatus();
                $timeout(function () {
                    focusFirstField('register-email-form');
                });
            }
            if (oldValue[ 'userLoggedIn' ] === false && newValue[ 'userLoggedIn' ] === true) {
                $scope.formStatus.guestLoggedIn = false;
                $scope.checkCheckoutPossible();
                $scope.updateCheckoutOptions();
            }
            else if (oldValue[ 'userLoggedIn' ] === true && newValue[ 'userLoggedIn' ] === false) {
                removeFormSubmitStatus();
            }
            if (oldValue[ 'updateMode' ] === false && newValue[ 'updateMode' ] === true) {
                $scope.formStatus.registerMode = false;
                $scope.formStatus.loginMode = false;
                $scope.checkCheckoutPossible();
                $timeout(function () {
                    focusFirstField('register-form');
                    document.querySelectorAll('.formerror:not([ng-show])').forEach(function (el) { el.textContent = ''; });
                });
            }
            if (oldValue[ 'updateMode' ] === true && newValue[ 'updateMode' ] === false) {
                $scope.checkCheckoutPossible();
            }
        }, true);

        $scope.$watch('cartItems', function (newValue, oldValue) {
            if (newValue === null || isEmpty(newValue)) {
                showEmptyCartModal();
            }
        });

        $scope.$watch('agbCheck', function (newValue, oldValue) {
            $scope.checkCheckoutPossible();
        });

        $scope.$watch('ticketsInCart', function (newValue, oldValue) {
            $scope.showClock = (newValue || ($scope.checkIfProductsInCart() && Config.config.carttimeouttype));
        });

        $scope.$watch('Voucher.item', function (item) {
            if (item === null || item === undefined) {
                $scope.voucherAnnouncement = '';
                return;
            }

            var redeemedAmount = $filter('currency')((item.price + Voucher.residualValue) * -1);
            var text = translations.voucher_announcement_title + '. ' +
                translations.voucher_announcement_code + ': ' + item.identifier + '. ' +
                translations.voucher_announcement_redeemed + ': ' + redeemedAmount + '. ';

            if (Cart.sum > 0) {
                text += translations.voucher_announcement_remaining_payment + ': ' + $filter('currency')(Cart.sum) + '.';
            } else {
                text += translations.voucher_announcement_residual.replace('[[XXX]]', $filter('currency')(Voucher.residualValue));
            }

            $timeout(function () {
                $scope.voucherAnnouncement = text;
            }, 1000);
        });

    };
    return service;

};

export default WatcherService;
